












import Component from 'vue-class-component';
import { Mixins } from 'vue-property-decorator';
import { mapGetters, mapState } from 'vuex';
import { SUBMODULES_PATHS } from '../../../store';
import { SEARCH_GETTERS_KEYS } from '../../../store/search/search.const';
import { FacetsGroupMixin } from '../../mixins/facets-group.mixin';

@Component({
  computed: {
    ...mapGetters(SUBMODULES_PATHS.search, {
      hasResults: SEARCH_GETTERS_KEYS.hasResults
    }),
    ...mapState(SUBMODULES_PATHS.search, [
      'query',
      'numFound'
    ])
  }
})
export default class ToggleFacetsGroup extends Mixins(FacetsGroupMixin) {
  query: string;
  numFound: number;
  hasResults: boolean;

  get renderToggleFacetsGroup() {
    return this.facetGroupConfig.collapsible && this.hasResults;
  }

  get toggleMessageParameters() {
    return {
      numFound: this.numFound,
      selectedFiltersCount: this.groupSelectedFilters.length,
      selectedFilters: this.groupSelectedFilters.map(filter => filter.title).join(', '),
      query: this.query
    };
  }

  get toggleMessage() {
    const toggleMessages = this.$x.messages.facets.toggle;
    if (this.facetsGroup.collapsed) {
      return toggleMessages.groups[this.groupId]?.outside?.openHTML ?? toggleMessages.default.openHTML;
    } else {
      return toggleMessages.groups[this.groupId]?.outside?.closeHTML ?? toggleMessages.default.closeHTML;
    }
  }
}
